import React, { useState, useCallback } from 'react';
import { Canvas } from '@react-three/fiber';
import { XR, createXRStore } from '@react-three/xr';

const store = createXRStore();

function Scene() {
  return (
    <>
      <ambientLight intensity={0.6} />
      <directionalLight position={[5, 10, 5]} intensity={1} />

      <mesh rotation={[-Math.PI / 2, 0, 0]}>
        <planeGeometry args={[50, 50]} />
        <meshStandardMaterial color="#2a2a3e" />
      </mesh>

      <mesh position={[0, 1, 0]}>
        <boxGeometry args={[1, 1, 1]} />
        <meshStandardMaterial color="red" />
      </mesh>

      <mesh position={[3, 1, -2]}>
        <sphereGeometry args={[0.7, 32, 32]} />
        <meshStandardMaterial color="green" />
      </mesh>

      <mesh position={[-3, 1.5, -2]}>
        <cylinderGeometry args={[0.5, 0.5, 3, 32]} />
        <meshStandardMaterial color="blue" />
      </mesh>
    </>
  );
}

export default function VRTest() {
  const [status, setStatus] = useState('Ready');

  const enterVR = useCallback(async () => {
    try {
      setStatus('Entering VR...');
      await store.enterVR();
      setStatus('In VR');
    } catch (e: any) {
      setStatus('Error: ' + e.message);
      console.error('VR entry failed:', e);
    }
  }, []);

  return (
    <div style={{ width: '100vw', height: '100vh', background: '#000' }}>
      <div style={{ position: 'absolute', top: 20, left: 20, zIndex: 10, color: 'white', fontFamily: 'monospace' }}>
        <h2 style={{ margin: 0 }}>VR Test</h2>
        <p>{status}</p>
        <button
          onClick={enterVR}
          style={{ padding: '16px 32px', fontSize: '20px', background: '#00c2b3', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer' }}
        >
          Enter VR
        </button>
      </div>

      <Canvas
        style={{ width: '100%', height: '100%' }}
        camera={{ position: [0, 1.6, 5], fov: 60 }}
      >
        <color attach="background" args={['#1a1a2e']} />
        <XR store={store}>
          <Scene />
        </XR>
      </Canvas>
    </div>
  );
}
